import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsDepartmentsListCreateRoute extends Route {
  @service store;

  model() {
    return this.store.createRecord('department');
  }
}

export default instrumentRoutePerformance(SettingsDepartmentsListCreateRoute);
